import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Stack } from '@metarouter-private/mr-mui';
import PlaybookTransformationOutput from 'app/shared/components/testing-suite/PlaybookTransformationOutput';

// Shared body for the chain's two transform-output tabs (Pipeline Output and
// Playbook Output). Mirrors the sibling tab components but takes the stage
// output as a prop so the two tabs are thin wrappers.
export default function AdvancedOutputTab({ output, trackingEventName, infoAlert }) {
  const { loading, error, outputEvent, errors } = output;
  if (error) {
    return null;
  }
  const outputProps = loading ? { loading } : { loading, outputEvent, outputErrors: errors };
  return (
    <Stack spacing={2}>
      {infoAlert && <Alert severity="info">{infoAlert}</Alert>}
      <PlaybookTransformationOutput {...outputProps} trackingEventName={trackingEventName} />
    </Stack>
  );
}

AdvancedOutputTab.propTypes = {
  output: PropTypes.object.isRequired,
  trackingEventName: PropTypes.string.isRequired,
  infoAlert: PropTypes.string,
};
